import { render, staticRenderFns } from "./DadosDoVeiculoAdmin.vue?vue&type=template&id=b31d1528&scoped=true"
import script from "./DadosDoVeiculoAdmin.vue?vue&type=script&lang=js"
export * from "./DadosDoVeiculoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31d1528",
  null
  
)

export default component.exports